import { isProduction as u } from "./Environment.js";
import { getCountryCode as d, getShortLanguageCode as h, getLocale as C } from "./I18N.js";
import { getNumberOfWeek as g } from "./Date.js";
const v = { APIKey: "TypeKit2", CCHomeUrl: "https://cchome-stage.adobe.io/int/v1/models", CCHomeCDNUrl: "https://stage-uis-cdn.creativecloud.adobe.com/int/v1/models", CCXUrl: "https://stage.projectx.corp.adobe.com", FontsUrl: "https://fonts-relstage.adobe.com" }, $ = { APIKey: "TypeKit2", CCHomeUrl: "https://cchome.adobe.io/int/v1/models", CCHomeCDNUrl: "https://uis-cdn.creativecloud.adobe.com/int/v1/models", CCXUrl: "https://new.express.adobe.com", FontsUrl: "https://fonts.adobe.com" };
function m() {
  return u() ? $ : v;
}
function U(o) {
  return `/fonts/${o}`;
}
function k(o, a) {
  const i = a.replace(/(\S+\s*){1,3}/g, `$&
`), n = ["width=1920", "height=1080", "unit=px", "aspectRatioLock=true", "requestor=af", `fontPostscriptName=${o}`, `fontSpecimen=${encodeURIComponent(i.trim())}`, "promoid=3F8XBFBG", "mv=other"];
  return `${m().CCXUrl}/new?${n.join("&")}`;
}
function f(o, a, i) {
  return new Promise((n, e) => {
    const s = (/* @__PURE__ */ new Date()).getTime();
    fetch(o).then((t) => {
      const c = (/* @__PURE__ */ new Date()).getTime();
      var r, l;
      return r = o, l = c - s, window.dispatchEvent(new CustomEvent("af-analytics", { detail: { componentName: "ccx-wavelength-api", eventName: "wavelength-api-response-time", url: r, responseTime: l } })), t.json();
    }).then((t) => {
      if (t.statusCode === 200) {
        const c = t.data.map((r) => ({ src: r.thumbnail, templateLink: `${m().CCXUrl}/sp/design/post/template/${r.id}?requestor=af&promoid=3F8XBFBG&mv=other`, fonts: r.fonts.map((l) => ({ name: l.psName, psName: l.psName, textFrame: l.textFrame, familySlug: "" })), templateDimensions: { width: r.size[0], height: r.size[1] }, showPremium: r.premium && !a, showActivationButton: !(r.premium && i && !a) }));
        n(c), "fallbacksUsed" in t && Object.keys(t.fallbacksUsed).length > 0 && p({ fallbacksUsed: !0, ...t.fallbacksUsed });
      } else "errors" in t ? (p({ status: t.errors[0].status, message: t.errors[0].title }), e(`[Crossbar]: ${t.errors[0].status} received from API call`)) : (p({ status: t.statusCode }), e(`[Crossbar]: ${t.statusCode} received from API call`));
    }).catch((t) => {
      var c;
      p({ errorName: t.name, errorMessage: t.message, error: t.toString(), errorStack: (c = t.stack) == null ? void 0 : c.toString() }), e(t);
    });
  });
}
function F(o, a, i, n) {
  let e = d().toLowerCase();
  e === "ud" && (e = "us");
  const s = [`country=${e}`, `week=${g(/* @__PURE__ */ new Date())}`, "sort=gs", `offset=${o}`, `limit=${a}`, `api_key=${m().APIKey}`];
  return f(`${m().CCHomeCDNUrl}/crossbar-templates-v1?${s.join("&")}`, i, n);
}
function P(o, a, i, n, e) {
  const s = [`font-family=${o}`, `offset=${a}`, `limit=${i}`, `api_key=${m().APIKey}`];
  return f(`${m().CCHomeCDNUrl}/crossbar-font-family-v1?${s.join("&")}`, n, e);
}
function D(o) {
  const a = [], i = {};
  return o.forEach((n) => {
    n.fonts.forEach((e) => {
      e.psName in i || (a.push(w(e.psName)), i[e.psName] = !0);
    });
  }), Promise.allSettled(a).then((n) => {
    const e = {};
    return n.forEach((s) => {
      if (s.status === "fulfilled") {
        const t = s.value;
        e[t.postscript_name] = t;
      }
    }), o.forEach((s) => {
      s.fonts.forEach((t) => {
        var r;
        const c = e[t.psName];
        c && (t.familySlug = (r = c.family) == null ? void 0 : r.slug, t.id = c.id, t.name = c.name);
      });
    }), o;
  });
}
function w(o) {
  let a = "en";
  h(C()) == "ja" && (a = "ja");
  const i = `https://apicdn.typekit.net/v1/variations/${o}?locale=${a}&include=full&api_key=${m().APIKey}`;
  return new Promise((n, e) => {
    fetch(i).then((s) => {
      if (s.status === 200) return s.json();
      e(`[Crossbar][FontMetadataAPI]: ${s.status} received from API call`);
    }).then((s) => n(s)).catch((s) => {
      e(s);
    });
  });
}
function p(o) {
  window.dispatchEvent(new CustomEvent("af-analytics", { detail: { componentName: "ccx-wavelength-api", eventName: "wavelength-api-call-error", ...o } }));
}
export {
  P as fetchCCXFamilyTemplates,
  F as fetchCCXSeasonalTemplates,
  D as fetchCCXTemplatesFontMetaData,
  w as fetchFontMetaDataFromCDN,
  k as getCCXOpenFontSpecimenHref,
  U as getFamilyOpenHref
};
//# sourceMappingURL=CCX.js.map
